module.exports = __webpack_public_path__ + "img/L1060786.0dae1a56.jpg";